module.exports = __webpack_public_path__ + "img/image-16.fca9b263.jpg";